import axios from 'axios';

export const sendCoSubscriber = payload => axios.post('/register/46', payload);
export const sendInvestmentCharacteristics = payload => axios.post('/register/41', payload);

export const sendSmsForVerification = () => axios.post('/users/phone-verification/sms');
export const checkCode = payload => axios.post('/users/phone-verification/check', payload);
export const sendAttestationSurHonneur = payload =>
    axios.post('/documents/affidavit/upload', payload, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

export const sendDistributorKYC = payload => axios.post('/register/42', payload);
export const confirmPerformancePedagogicalStep = () => axios.post('/register/40');
export const uploadIdDocument = (payload, stepId) =>
    axios.post(`/register/${stepId}`, payload, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
